import React from "react";
import "./FirstPeriodDesc.css";

const FirstPeriodDesc = () => {
  const content = [
    {
      title: "First Periods",
      description:
        "Wondering when you can expect your first period? It's normal to be nervous about it, but don't worry—you've got this! Most people get their first period sometime between the ages of 12 and 14. We're here to help you learn the signs you can look out for that will tell you that your first period is just around the corner.",
      video: "https://www.youtube.com/embed/AV5UClOFANQ?si=UdVZNA4xwTeK0RfH",
    },
    {
      title: "Embrace Your Amazing Body",
      description:
        "Hey there, superstar! Did you know that your body is capable of incredible things? It's true! One of the amazing things it can do is called menstruation. Even if that's a long way off, your body is still doing its thing, and it's all perfectly normal and awesome!",
        video: "https://www.youtube.com/embed/5u6Y6ZP2_Wg",
    },
    {
      title: "The Awesome Signs of Your Superpowers",
      description:
        "As you grow up, your body starts to change in interesting ways. You might notice your breasts getting a little bigger or some hair showing up in new places. These are signs that your body is gearing up for your first period!",
        video: "https://www.youtube.com/embed/qUNTtn1WPEw",
    },
    {
      title: "Gear Up for Period Adventures",
      description:
        "Your first period might be right around the corner, and it's always good to be ready. Keep period supplies like pads or tampons handy, and you'll be all set for the adventure!",
      video: "https://www.youtube.com/embed/ImzxzlPzbRk?si=HYSKNKco5tx-2XMe",
    },
    {
        title: "Understanding Changes in Your Body",
        description:
          "Your body is like a magical garden, constantly growing and changing! As you approach your first period, you'll notice little signs, like changes in your skin, mood swings, or even a newfound appreciation for chocolate. These changes are part of the amazing journey your body is taking!",
        video: "https://www.youtube.com/embed/qFLElwY-SYE", // Replace with the desired video link or remove if not needed.
      },
      {
        title: "Your First Period: What to Expect",
        description:
          "When your first period arrives, it might feel like a surprise party that you weren’t sure was happening! Don't worry—it's a natural and normal part of growing up. Keep some pads or tampons ready, and remember, it’s okay to talk to someone you trust if you have questions or need help.",
        video: "https://www.youtube.com/embed/cfROFgkV43E", // Replace with the desired video link or remove if not needed.
      },
      
  ];

  return (
    <div className="page-container">
      <h1 className="heading">First Periods Guide</h1>
      <div className="grid-container">
        {content.map((item, index) => (
          <div className="card" key={index}>
            <h2 className="subheading">{item.title}</h2>
            <p className="text">{item.description}</p>
            {item.video && (
              <iframe
                className="video"
                src={item.video}
                title={`Video ${index + 1}`}
                allowFullScreen
              ></iframe>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FirstPeriodDesc;
